<script lang="ts" setup>
import AUApi from "@/api";
import { ref, onMounted, reactive } from "vue";
import { mountedBase, BaseSetup, onSave } from "@/DataLoaderStatic";
import { getKennungValueDisplay, getKennungTitle } from "@/DataHelper";
const emit = defineEmits(["back"]);
const props = defineProps<{
  showMemo: boolean;
  zeitbereichUebergabe: APIZeitbereich;
  aic: number;
}>();

const pageParams: DataPageParameter = {
  zeitbereich: AUApi.Current.zeitbereich,
  insertMode: false,
  query: "Web_ReiseDatenVG_Details",
  emitBack: () => emit("back"),
};
const uiData = reactive<DataPageUIData>(BaseSetup(pageParams));
onMounted(async () => {
  pageParams.queryAIC = props.aic;
  pageParams.zeitbereich = props.zeitbereichUebergabe;
  await mountedBase(uiData, pageParams);
  uiData.showLoading = false;
  uiData.initialized = true;
});
</script>
<template>
  <v-card tile class="pa-0 pt-2" :loading="uiData.showLoading" >
    <v-card-text v-if="uiData.initialized">
      <v-row>
        <v-col class="dvhCol">
          <span style="white-space: nowrap"
            >{{ getKennungTitle("KOSTENSTELLENZUORDNG", uiData.columns) }}:
          </span>
        </v-col>
        <v-col class="dvhCol">
          <span style="white-space: nowrap">{{
            getKennungValueDisplay(uiData.data[0], "KOSTENSTELLENZUORDNG", uiData.columns)
          }}</span>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="dvhCol">
          <span style="white-space: nowrap"
            >{{ getKennungTitle("HIERARCHIEOFFICE", uiData.columns) }}:
          </span>
        </v-col>
        <v-col class="dvhCol">
          <span style="white-space: nowrap">{{
            getKennungValueDisplay(uiData.data[0], "HIERARCHIEOFFICE", uiData.columns)
          }}</span>
        </v-col>
      </v-row>
      <EditFileChoicer
        class="pt-6"
        :readonly="true"
        kennung="DOKUMENT_DATENBANK"
      />
    </v-card-text>
  </v-card>
</template>
<style scoped>
.row {
  padding: 0px;
}
.dvhCol {
  padding-right: 0px;
  padding-left: 10px;
  padding-top: 0px;
  padding-bottom: 5px;
  align-items: left;
  text-align: left;
}
</style>
